
export const menuData = [
  {
    title: "Inicio",
    key: "/",
  },
  {
    title: "Términos y Condiciones",
    key: "/terminos",
  },
  {
    title: "Política de Privacidad",
    key: "/pdp",
  },
  {
    title: "Ayuda",
    key: "/ayuda",
  },
  {
    title: "Quejas y Reclamos",
    key: "/arrepentimiento",
  },
  {
    title: "Eliminar cuenta",
    key: "/cancelar",
  },
]

export const thirdData = [
  {
    icon: "icon2",
    label: "Rellena la información básica"
  },
  {
    icon: "icon3",
    label: "Enviar un pedido de solicitud"
  },
  {
    icon: "icon4",
    label: "Esperando a que lleguen los fondos"
  }
]

export const fourthData = [
  {
    title: "Alicia",
    desc: "Considero que Pitage te oferece préstamo con la mejor tasa de interés en comparación con otras aplicaciones similares. Sin duda de las mejores"
  },
  {
    title: "Lucio",
    desc: "Si necesitas ayuda para un préstamo, te recomiendo que descargues y utilices esta aplicación. Es muy fácil y te ayudarán paso a paso. Yo lo he hecho y realmente lo recomiendo, solo espero y realmente recibo mi préstamo, no espero tanto como otras aplicaciones."
  },
  {
    title: "Irene",
    desc: "Muy buena aplicación, importe razonable de los intereses, condiciones adecuadas, muy buena aplicación recomendada."
  },
  {
    title: "Lucas",
    desc: "Préstamos rápidos, no tan procedimentales. Préstamos como estos son de gran ayuda para usted y lo más importante, son rápidos en cualquier urgencias ...... Sin duda, es una buena opción."
  },
]

export const GOOGLE_PLAY_LINK = "https://play.google.com/store/apps/details?id=com.la.pitagee.app";
